import cookieHelper, { SKIP_BLOCK_EDITABLE_LAST_MONTH_KEY, SKIP_BLOCK_EDITABLE_LAST_MONTH_VALUE } from 'helpers/cookieHelper';
import { dateHelper } from 'helpers/dateHelper';
import { getTableHeightFitContent } from 'helpers/lib/reactDataGridHelpers';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import ReactDataGrid from 'react-data-grid';

const EmptyRowsView = () => {
    const message = 'Chưa có mục chi nào';
    return (
        <div style={{ textAlign: 'center', backgroundColor: '#ddd', padding: '100px' }}>
            <h3>{message}</h3>
        </div>
    );
};

function ChiNoiTruList({ danhMucChiNoiTrus, chiNoiTrus, data, setData, monthYear }) {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const [tableHeight, setTableHeight] = useState();
    useEffect(() => {
        setTableHeight(getTableHeightFitContent());
    }, []);

    useEffect(() => {
        const rows = [];
        if (danhMucChiNoiTrus) {
            danhMucChiNoiTrus.forEach((dm) => {
                const matchedChiNoiTru = chiNoiTrus.find((chiNoiTru) => chiNoiTru.code === dm.code);
                const row = {
                    dmId: dm.id,
                    code: dm.code,
                    name: dm.name,
                    amount: matchedChiNoiTru ? matchedChiNoiTru.amount : '',
                    usdAmount: matchedChiNoiTru ? matchedChiNoiTru.usdAmount : '',
                    eurAmount: matchedChiNoiTru ? matchedChiNoiTru.eurAmount : '',
                    notes: matchedChiNoiTru ? matchedChiNoiTru.notes : '',
                    collectDate: matchedChiNoiTru ? dateHelper.formatDate(matchedChiNoiTru.collectDate) : '',
                    dm: matchedChiNoiTru,
                };
                rows.push(row);
            });
            setRows(rows);
        }
    }, [danhMucChiNoiTrus, chiNoiTrus]);

    useEffect(() => {
        const readOnly = cookieHelper.getCookie(SKIP_BLOCK_EDITABLE_LAST_MONTH_KEY) !== SKIP_BLOCK_EDITABLE_LAST_MONTH_VALUE && dateHelper.isAfterNextMonth10thDate(monthYear);

        const columns = [
            { key: 'code', name: 'Mã số', editable: false, width: 60 },
            { key: 'name', name: 'Diễn giải', editable: false, width: 360 },
            { key: 'amount', name: 'VND (ĐV: 1000đ)', editable: !readOnly, width: 180 },
            { key: 'usdAmount', name: 'USD', editable: !readOnly, width: 80 },
            { key: 'eurAmount', name: 'EUR', editable: !readOnly, width: 80 },
            { key: 'notes', name: 'Ghi chú', editable: !readOnly, width: 200 },
            { key: 'collectDate', name: 'Ngày ghi', editable: false, width: 200 },
        ];
        setColumns(columns);
    }, [monthYear]);

    const onGridRowsUpdated = ({ fromRow, toRow, updated, cellKey }) => {
        const newData = new Map(data);
        const newRows = [...rows];
        for (let i = fromRow; i <= toRow; i++) {
            newRows[i] = { ...newRows[i], ...updated };
            if (get(newRows[i], 'dm.id', false) || updated[cellKey] !== '') {
                newData.set(i, newRows[i]);
            }
        }
        setRows(newRows);
        setData(newData);
    };

    return (
        <div id="rdg">
            <ReactDataGrid
                columns={columns}
                rowGetter={(i) => rows[i]}
                rowsCount={rows.length}
                minHeight={tableHeight}
                enableCellSelect={true}
                onGridRowsUpdated={onGridRowsUpdated}
                emptyRowsView={EmptyRowsView}
            />
        </div>
    );
}

export default ChiNoiTruList;
